import styled from 'styled-components'
import * as BaseUI from '../../../ui/login.styled'

export const LoginButton = styled(BaseUI.LoginButton)`
  //min-width: 175px;

  &:hover {
    background: #F5F5F7;
  }
  
  &:active {
    background: #EBECEF;
  }
`

export const LoginButtonInner = styled(BaseUI.LoginButtonInner)`
`
